<template>
  <div class="menu-idiomas col-12 text-center">
    <ul class="idiomas">
      <li :class="[{'seleccionado': currentLanguage=='es'}]">
        <img src="https://www.alberguesyrefugios.com/img/es.png" @click="cambiaIdioma('es')" alt="">
      </li>
      <li :class="[{'seleccionado': currentLanguage=='en'}]">
        <img src="https://www.alberguesyrefugios.com/img/en.png" @click="cambiaIdioma('en')" alt="">
      </li>
      <li :class="[{'seleccionado': currentLanguage=='fr'}]">
        <img src="https://www.alberguesyrefugios.com/img/fr.png" @click="cambiaIdioma('fr')" alt="">
      </li>
      <li :class="[{'seleccionado': currentLanguage=='ca'}]">
        <img src="https://www.alberguesyrefugios.com/img/ca.png" @click="cambiaIdioma('ca')" alt="">
      </li>
    </ul>
  </div>
</template>

<script>

  import {languageService} from "../../_services";
  import {errorOptions, langChange} from "../../_config";

  export default {
    name: "select-language",
    props: ["idioma"],
    data() {
      return {
        currentLanguage: ''
      }
    },
    created(){
      this.currentLanguage = this.idioma || 'es';
    },
    methods: {
      cambiaIdioma(lang){
        this.currentLanguage = lang;
        this.$store.commit('changeLanguage',lang);
        languageService.changeLang(lang).then( rdo => {
          toastr.options = errorOptions
          toastr["success"](langChange[lang] + " 👍")

        })
        //Comunicarlo a todos los componentes
        this.$emit('changeLanguage', this.currentLanguage);
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/shared/SelectLanguage.vue